module.exports = {
  iconExpandData: "data:image/svg+xml,%3csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M2.004 16.593l5.338-5.284a1 1 0 111.407 1.42l-5.326 5.273h3.17a1 1 0 110 2H1.004a1 1 0 01-1-1v-5.624a1 1 0 012 0v3.215zM16.608 2h-3.205a1 1 0 010-2H19a1 1 0 011 1v5.568a1 1 0 01-2 0V3.437L12.724 8.72a1 1 0 11-1.415-1.413L16.609 2z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconExpandWidth: 20,
  iconExpandHeight: 20
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/tokens/base/icon/expand.js
// module id = 396
// module chunks = 7